import api from './authService'

export interface EstimationConfig {
  developers: number
  qa: number
  experience: 'Junior' | 'Mid' | 'Senior'
  duration?: string
  techDescription?: string
}

export interface EstimationResult {
  overview: string
  scope: string
  techStack: Array<{ module: string; technology: string }>
  specifications: Record<string, string[]>
  goals: string[]
  sprints: Array<{
    sprint: string
    functionality: string
    days: number
    tasks: string[]
  }>
  summary: {
    testingUat: string
    deployment: string
    totalDays: number
  }
}

export const estimationService = {
  async generateEstimation(projectId: string, config: EstimationConfig): Promise<{ success: boolean; data: EstimationResult; message?: string; error?: string }> {
    try {
      const response = await api.post(`/projects/${projectId}/estimation`, config)
      return response.data
    } catch (err: any) {
      return {
        success: false,
        data: null as any,
        message: err.response?.data?.message || err.message || 'Failed to generate estimation',
        error: err.response?.data?.error
      }
    }
  },

  async clearEstimation(projectId: string): Promise<{ success: boolean; message?: string }> {
    try {
      const response = await api.delete(`/projects/${projectId}/estimation`)
      return response.data
    } catch (err: any) {
      return {
        success: false,
        message: err.response?.data?.message || err.message || 'Failed to clear estimation',
      }
    }
  }
}
